import * as T from '@/types'

export default {

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////

    API: {
        URL: process.env.VUE_APP_API_URL,
        PENDING_TRANSACTION_LIMIT: 10,
        TRANSACTION_UID_DELIMITER: '/',
        DROPDOWN_SEARCH_LIMIT: 10,
        API_KEY: process.env.VUE_APP_API_KEY,
    },

    ////////////////////////////////////////////////////////////////
    // tokens
    ////////////////////////////////////////////////////////////////

    TOKEN: {
        INSPECTION_INTERVAL_IN_SECONDS: 5 * 60, // Token is inspected every 5 minutes.
        REFRESH_THRESHOLD_IN_SECONDS: 40 * 60, // Token will only be refreshed if there are at most 40 minutes until it expires.
    },

    ////////////////////////////////////////////////////////////////
    // pinger
    ////////////////////////////////////////////////////////////////

    PING: {
        INTERVAL_IN_SECONDS: 5 * 60, // Ping every 5 minutes to indicate that user is active.
    },

    REFRESH: {
        INTERVAL_IN_SECONDS: 1 * 60, // Refresh extended user every minute.
    },

    ////////////////////////////////////////////////////////////////
    // routes
    ////////////////////////////////////////////////////////////////

    ROUTE: {
        DEFAULT_UNAUTHORIZED_ROUTE_NAME: T.CrmRoute.AUTH_ACCESS_CODE_LOGIN,
        DEFAULT_AUTHORIZED_ROUTE_NAME: T.CrmRoute.ACCOUNT_HOME,
    },


    ////////////////////////////////////////////////////////////////
    // date/time
    ////////////////////////////////////////////////////////////////

    DATE_TIME: {
        ABSOLUTE_FORMAT_IN_DAYS: 'Do MMM YYYY',
        ABSOLUTE_FORMAT: 'Do MMM YYYY @ HH:mm',
        ABSOLUTE_FORMAT_WITH_SECONDS: 'Do MMM YYYY @ HH:mm:ss',
        TIMECODE_DAY: 'YYYYMMDD',
        TIMECODE_HOUR: 'YYYYMMDDHH',
    },


    ////////////////////////////////////////////////////////////////
    // WebSockets
    ////////////////////////////////////////////////////////////////

    // WEBSOCKET: {
    //     BROADCASTER: 'pusher',
    //     AUTH_ENDPOINT: process.env.VUE_APP_PUSHER_AUTH_ENDPOINT,
    //     KEY: process.env.VUE_APP_PUSHER_APP_KEY,
    //     CLUSTER: process.env.VUE_APP_PUSHER_CLUSTER,
    //     ENCRYPTED: true,
    //     HISTORY_LIMIT: 50,
    //     IS_TYPING_INTERVAL: 2000,
    //     PLATFORM_CHANNEL_UID: process.env.VUE_APP_PLATFORM_SOCKET_CHANNEL,
    // },

    ////////////////////////////////////////////////////////////////
    // UI
    ////////////////////////////////////////////////////////////////

    UI: {
        TOAST_DURATION_IN_MILLISECONDS: 8000,
        TOAST_AMOUNT_LIMIT: 3,

        // TODO: Use this.
        /**
         * Maximum number of items that can be selected for a bulk action,
         * therefore, the maximum number of items that can be shown in any view
         * where entities can be selected and have bulk actions applied to them.
         * 
         * This value should be in sync with MULTIPLE_ENTITY_QUERY_MAX_IDS in API's .env file.
         */
        SELECTABLE_ENTITY_COUNT_LIMIT: 500,

        SELECTION_HISTORY_LIMIT: 20,
        TIME_SEPARATION_THRESHOLD_IN_MINUTES: 10,
        SCROLLED_TO_BOTTOM_THRESHOLD_IN_REM: 1,
        TEXT_INPUT_DEBOUNCE_IN_MILLISECONDS: 1000,
        TOOLTIP_SHOW_DELAY_IN_MILLISECONDS: 300,
        TOOLTIP_HIDE_DELAY_IN_MILLISECONDS: 0,

        MINIMUM_VIEWPORT_WIDTH_BEFORE_SCALING: 640,
        MINIMUM_VIEWPORT_HEIGHT_BEFORE_SCALING: 800,
    },

    // EMBED: {
    //     SCRIPT_URL: process.env.VUE_APP_EMBED_SCRIPT_URL,
    // },

    SUPPORT: {
        SUPPORT_EMAIL_ADDRESS: 'support@creditordesk.com',
        INBOUND_EMAIL_DOMAIN: process.env.VUE_APP_INBOUND_EMAIL_DOMAIN,
    },

    // STRIPE: {
    //     KEY: process.env.VUE_APP_STRIPE_KEY,
    // },

}
